import React from "react";
import './styles.scss'

interface CardProps{
    foto:string
    mensagem:string
}

const Card = ({foto,mensagem} :CardProps) => {
    return(
        <div className="CardConteiner">
            <div>
                <img src={`/images/projetos/${foto}.png`} width={390}/>
            </div>
            <p>{mensagem}</p>
        </div>
    );
}
export default Card